import { Typography, TypographyProps } from '@mui/material';

import clsx from 'clsx';

export const NavText = ({ children, className, ...typographyProps }: TypographyProps) => (
  <Typography className={clsx('nav-text', className)} variant="button.medium" component="span" {...typographyProps}>
    {children}
  </Typography>
);
